import { render, staticRenderFns } from "./feedback-comment-form.vue?vue&type=template&id=0842293f&scoped=true"
import script from "./feedback-comment-form.vue?vue&type=script&lang=js"
export * from "./feedback-comment-form.vue?vue&type=script&lang=js"
import style0 from "./feedback-comment-form.vue?vue&type=style&index=0&id=0842293f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0842293f",
  null
  
)

export default component.exports